import { useAtom, useSetAtom } from 'jotai'
import React, { useCallback } from 'react'

import {
  modalTriggererAtom,
  selectedAppointmentIdAtom,
  selectedPractitionerIdAtom,
} from '../../../state/appointmentOptionsSelect/atoms'
import { AppointmentOptions } from '../components/AppointmentOptionsSelectModal'
import AppointmentOptionsSelectModalWrapper from '../components/AppointmentOptionsSelectModalWrapper'

interface Props {
  onSelectUnavailableDuration(practitionerId: number, duration: number): void
  onSelect(appointmentId: number, options: AppointmentOptions): void
}

const AppointmentOptionsSelectContainer: React.FC<React.PropsWithChildren<Props>> = ({
  onSelect,
  onSelectUnavailableDuration,
}) => {
  const setModalTriggerer = useSetAtom(modalTriggererAtom)
  const [practitionerId, setPractitionerId] = useAtom(selectedPractitionerIdAtom)
  const [appointmentId, setAppointmentId] = useAtom(selectedAppointmentIdAtom)

  const closeModal = useCallback(() => {
    setModalTriggerer(undefined)
    setPractitionerId(undefined)
    setAppointmentId(undefined)
  }, [setModalTriggerer, setAppointmentId, setPractitionerId])

  if (!practitionerId || !appointmentId) {
    return null
  }

  return (
    <AppointmentOptionsSelectModalWrapper
      appointmentId={appointmentId}
      practitionerId={practitionerId}
      onClose={() => {
        closeModal()
      }}
      onSelect={(appointmentOptions) => {
        closeModal()
        onSelect(appointmentId, appointmentOptions)
      }}
      onSelectUnavailableDuration={(duration) => {
        closeModal()
        onSelectUnavailableDuration(practitionerId, duration)
      }}
    />
  )
}

export default AppointmentOptionsSelectContainer
